<template>

  <div id="admin-members-detail" class="admin-members wrap">
    <h1 class="wp-heading-inline">会員データ編集</h1>

    <div class="d-flex justify-content-between mt-1 mb-3">
      <a class="btn btn-sm btn-outline-secondary btnBackToList" v-on:click.prevent="back_to_list" href="#">
        <i class="fas fa-angle-left mr-2"></i>会員リストへ戻る
      </a>
    </div>

    <!-- / -->
    <b-alert v-if="loading.delete" show variant="info">
      <b-spinner small variatn="info" class="mr-2" label="Loading..."></b-spinner>会員を削除しています…
    </b-alert>
    <!-- / -->
    <b-alert v-if="!loading.delete && show_member_delete_error" show variant="danger">
      会員の削除中にエラーが発生しました。
    </b-alert>
    <!-- / -->
    <b-form v-if="!member_deleted" name="memberData">

      <table class="table table-bordered tblMemberDetail">
        <thead>
          <tr>
            <th colspan="2">
              <div class="d-flex flex-wrap">
                <span class="mr-5">会員情報編集</span>
                <div class="ml-auto text-right">
                  <span class="d-inline-block">登録日時：{{propsCreatedAt}}</span>
                  <span class="d-inline-block ml-4">最終更新日時：{{updated_at}}</span>
                </div>
              </div>
            </th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <th>会員ID</th>
            <td><span class="memberId">{{propsId}}</span></td>
          </tr>

          <tr>
            <th>名前</th>
            <td>
              <div class="d-md-flex">
                <div class="memberNameItem d-flex align-items-baseline mb-2 mb-md-0">
                  姓：
                  <b-form-input v-validate="{
                                  required:true,
                                  max:45
                                }"
                                v-model.trim="form.last_name"
                                type="text"
                                name="last_name"
                                data-vv-as="姓">
                  </b-form-input>
                </div>
                <div class="memberNameItem d-flex align-items-baseline">
                  名：
                  <b-form-input v-validate="{
                                  required:true,
                                  max:45
                                }"
                                v-model.trim="form.first_name"
                                name="first_name"
                                data-vv-as="名"
                                type="text">
                  </b-form-input>
                </div>
              </div>
              <!-- / -->
              <b-alert v-if="veeErrors.first('last_name') || veeErrors.first('first_name')" show variant="danger" class="mt-3 mb-0">
                <p v-if="veeErrors.first('last_name')" class="p-0 m-0">{{veeErrors.first('last_name')}}</p>
                <p v-if="veeErrors.first('first_name')" class="p-0 m-0">{{veeErrors.first('first_name')}}</p>
              </b-alert>
              <!-- / -->
            </td>
          </tr>

          <tr>
            <th>所属機関及び役職</th>
            <td>
              <b-form-input v-validate="{
                              required:true,
                              max:255
                            }"
                            v-model.trim="form.belonging"
                            type="text"
                            name="belonging"
                            data-vv-as="所属機関及び所属名">
              </b-form-input>
              <!-- / -->
              <b-alert v-if="veeErrors.first('belonging')" show variant="danger" class="mt-3 mb-0">
                {{veeErrors.first('belonging')}}
              </b-alert>
              <!-- / -->
            </td>
          </tr>

          <tr>
            <th>メールアドレス<br class="d-md-none">（ユーザーID）</th>
            <!-- / -->
            <td>
              <!-- / -->
              <b-form-checkbox v-model="email_change" switch style="line-height:23px;">
                <template v-if="!email_change">変更しない</template>
                <template v-else><b>変更する</b></template>
              </b-form-checkbox>
              <!-- / -->
              <div v-if="!email_change">
                <hr>
                {{propsEmail}}
              </div>
              <!-- / -->
              <div v-if="email_change" class="mt-4">
                <hr>
                <b-form-input v-validate="{
                                required:true,
                                email:true,
                                max:190
                              }"
                              v-model.trim="form.email"
                              name="email"
                              data-vv-as="メールアドレス"
                              v-on:blur="check_email_available"
                              class="memberEmail">
                </b-form-input>
                <!-- / -->
                <b-alert v-if="veeErrors.first('email')" show variant="danger" class="mt-3 mb-0">
                  {{veeErrors.first('email')}}
                </b-alert>
                <!-- / -->
                <b-alert v-if="form.email && !veeErrors.first('email') && email_check_loading" show variant="info" class="mt-3 mb-0">
                  <b-spinner small variant="info" label="Spinning"></b-spinner>
                  メールアドレスを確認中…
                </b-alert>
                <!-- / -->
                <b-alert v-if="form.email && form.email == checked_email_address && !veeErrors.first('email') && !email_check_loading && !email_available" show variant="danger" class="mt-3 mb-0">
                  <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                  このメールアドレスは申請済みです。
                </b-alert>
                <!-- / -->
                <b-alert v-if="form.email && form.email == checked_email_address && !veeErrors.first('email') && !email_check_loading && email_available" show variant="success" class="mt-3 mb-0">
                  <i class="fa fa-thumbs-o-up" aria-hidden="true"></i>
                  このメールアドレスは利用できます。
                </b-alert>
                <!-- / -->
              </div>
            </td>
            <!-- / -->
          </tr>

          <tr>
            <th>会員承認</th>
            <td>
              <b-form-select v-model="form.approve"
                             v-bind:options="approve_options"
                             name="memberApproval"
                             class="selectApproval">
              </b-form-select>
              <p class="text-secondary mt-2 mb-0">※登録内容に問題がなければ「承認する」を選択してください。</p>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- / -->
      <div class="d-flex align-items-baseline justify-content-end">
        <span>
          <b-button v-b-modal.modal-member-delete
                    v-bind:disabled="loading.update"
                    variant="link"
                    size="sm"
                    class="memberDeleteLink mr-4">
            会員削除
          </b-button>
        </span>
        <b-button v-bind:disabled="veeErrors.any() || (email_change && !email_available) || loading.update"
                  v-on:click.prevent="update_member"
                  name="memberDataUpdate"
                  size="sm"
                  variant="primary"
                  style="width:152px;"
                  class="btnUpdate">
          <span v-if="loading.update"><b-spinner small label="Spinner"></b-spinner></span>
          <span v-else>会員情報を更新する</span>
        </b-button>
      </div>
      <!-- / -->

      <!-- Modal Box -->
      <b-modal id="modal-member-delete"
               title="会員削除の確認"
               ok-title="削除する"
               ok-variant="danger"
               v-on:ok="delete_member"
               cancel-title="削除しない">
        <p class="my-2">
          本当に会員削除してよろしいですか？<br>
          会員削除をすると、会員データが消去されます。<br>
          <span class="text-danger">（※この操作は元に戻せません。）</span>
        </p>
      </b-modal>
      <!-- /Modal Box -->
    </b-form>
    <!-- / -->
    <b-alert v-if="!loading.delete && member_deleted && !show_member_delete_error" show variant="success">
      この会員は削除されました。
    </b-alert>
    <!-- / -->
  </div>

</template>

<script>
    //import mixin
    import common from '../../../mixins/common';

    //vue
    export default {
        mixins: [common],
        props: {
          propsId: {
            type: Number
          },
          propsLastName: {
            type: String
          },
          propsFirstName: {
            type: String
          },
          propsBelonging: {
            type: String
          },
          propsEmail: {
            type: String
          },
          propsApprovedAt: {
            type: String
          },
          propsCreatedAt: {
            type: String
          },
          propsUpdatedAt: {
            type: String
          }
        },
        data: function() {
          return {
            form: {
              last_name: '',
              first_name: '',
              belonging: '',
              email: '',
              approve: null
            },
            approve_options: [
              {
                text: '承認しない',
                value: false
              },
              {
                text: '承認する',
                value: true
              }
            ],
            email_check_loading: false,
            checked_email_address: null,
            email_available: false,
            email_change: false,
            member_deleted: false,
            show_member_delete_error: false,
            show_member_update_error: false,
            updated_at: null,
            loading: {
              update: false,
              delete: false
            }
          };
        },
        mounted() {
            console.log('MembersDetailComponent mounted.')

            //props to data
            this.form.last_name  = this.propsLastName;
            this.form.first_name = this.propsFirstName;
            this.form.belonging  = this.propsBelonging;
            this.form.email      = this.propsEmail;
            this.updated_at      = this.propsUpdatedAt;

            if(this.propsApprovedAt) {
              this.form.approve = true;
            }
            else {
              this.form.approve = false;
            }

        },
        methods: {
          back_to_list: function() {
            history.back(-1);
          },
          check_email_available: function() {

            var _self = this;

            //check email changed
            if(this.form.email == this.checked_email_address) {
              return;
            }

            //loading
            this.email_check_loading = true;

            //init
            this.email_available = false;

            //api
            this.api().check_email_available(this.form.email, function(api_response){
              var data = api_response.data;
              _self.checked_email_address = _self.form.email;
              _self.email_available = data.email_available;
              _self.email_check_loading = false;
            });
          },
          delete_member: function() {

            //loading
            this.loading.delete = true;

            //member_id
            var member_id = this.propsId;
            if(!member_id) {
              return false;
            }

            //api
            var _self = this;
            this.api().delete_member(member_id,function(api_response){

              var result = api_response.data.result;
              if(result == 'SUCCESS') {
                _self.member_deleted = true;
              }
              else {
                _self.member_deleted = false;
                _self.show_member_delete_error = true;
              }

              //loading
              _self.loading.delete = false;
            });

          },
          update_member: function() {

            //loading
            this.loading.update = true;

            //member_id
            var member_id = this.propsId;
            if(!member_id) {
              return false;
            }

            //param
            var param = {
              'updated_at': moment().format('YYYY-MM-DD HH:mm:ss'),
              'last_name': this.form.last_name,
              'first_name': this.form.first_name,
              'belonging': this.form.belonging
            };

            //approved_at
            if(this.form.approve) {
              param['approved_at'] = moment().format('YYYY-MM-DD HH:mm:ss');
            }
            else {
              param['approved_at'] = null;
            }

            //email_change
            if(this.email_change) {
              param['email'] = this.form.email;
            }

            //api
            var _self = this;
            this.api().update_member(member_id,param,function(api_response){

                var result = api_response.data.result;

                if(result == 'ERROR') {
                  _self.show_member_update_error = true;
                  _self.make_toast('会員情報を更新中にエラーが発生しました。','danger');
                }
                else if(result == 'SUCCESS') {
                  //member
                  var member = api_response.data.member;

                  //updated_at
                  _self.updated_at = member.updated_at;

                  //show message
                  _self.show_member_update_error = false;
                  _self.make_toast('会員情報を更新しました。','success');
                }

                //loading
                _self.loading.update = false;
            });

          }
        }
    }
</script>
